// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2494) return "component.accordion-section.min.js?v=1757927405232";
	if (chunkId === 3372) return "component.accordion-snippet.min.js?v=1757927405232";
	if (chunkId === 5652) return "component.breadcrumbs.min.js?v=1757927405232";
	if (chunkId === 9602) return "component.cart-drawer.min.js?v=1757927405232";
	if (chunkId === 9283) return "component.collection-doorways.min.js?v=1757927405232";
	if (chunkId === 2267) return "component.collection-hero.min.js?v=1757927405232";
	if (chunkId === 567) return "component.customers-account.min.js?v=1757927405232";
	if (chunkId === 1167) return "component.customers-activate-account.min.js?v=1757927405232";
	if (chunkId === 5342) return "component.customers-addresses.min.js?v=1757927405232";
	if (chunkId === 8021) return "component.customers-login.min.js?v=1757927405232";
	if (chunkId === 6142) return "component.customers-order.min.js?v=1757927405232";
	if (chunkId === 2241) return "component.customers-orders.min.js?v=1757927405232";
	if (chunkId === 9169) return "component.customers-register.min.js?v=1757927405232";
	if (chunkId === 4915) return "component.customers-reset-password.min.js?v=1757927405232";
	if (chunkId === 8413) return "component.featured-collection.min.js?v=1757927405232";
	if (chunkId === 4438) return "component.heading-copy.min.js?v=1757927405232";
	if (chunkId === 4445) return "component.hero-banner.min.js?v=1757927405232";
	if (chunkId === 2813) return "component.hotspot-section.min.js?v=1757927405232";
	if (chunkId === 7515) return "component.in-grid-banner.min.js?v=1757927405232";
	if (chunkId === 4458) return "component.main-404.min.js?v=1757927405232";
	if (chunkId === 496) return "component.main-article.min.js?v=1757927405232";
	if (chunkId === 7086) return "component.main-blog.min.js?v=1757927405232";
	if (chunkId === 5584) return "component.main-cart.min.js?v=1757927405232";
	if (chunkId === 2158) return "component.main-collection.min.js?v=1757927405232";
	if (chunkId === 5478) return "component.main-list-collections.min.js?v=1757927405232";
	if (chunkId === 9827) return "component.main-page.min.js?v=1757927405232";
	if (chunkId === 5371) return "component.main-product.min.js?v=1757927405232";
	if (chunkId === 8422) return "component.main-search.min.js?v=1757927405232";
	if (chunkId === 5344) return "component.multi-column.min.js?v=1757927405232";
	if (chunkId === 5659) return "component.multi-video.min.js?v=1757927405232";
	if (chunkId === 299) return "component.newsletter-sign-up.min.js?v=1757927405232";
	if (chunkId === 2068) return "component.product-recommendations.min.js?v=1757927405232";
	if (chunkId === 1998) return "component.promo-banner.min.js?v=1757927405232";
	if (chunkId === 7733) return "component.site-footer.min.js?v=1757927405232";
	if (chunkId === 3087) return "component.text-and-image.min.js?v=1757927405232";
	if (chunkId === 733) return "component.transition-height.min.js?v=1757927405232";
	if (chunkId === 2300) return "component.trustpilot-placement.min.js?v=1757927405232";
	if (chunkId === 8861) return "web.collectors-customer-hero.min.js?v=1757927405232";
	if (chunkId === 4698) return "web.factory-details.min.js?v=1757927405232";
	if (chunkId === 4499) return "web.faq-page.min.js?v=1757927405232";
	if (chunkId === 6266) return "web.locked-collectors-content.min.js?v=1757927405232";
	if (chunkId === 9303) return "web.product-trustpilot-section.min.js?v=1757927405232";
	if (chunkId === 4594) return "web.request-catalogue.min.js?v=1757927405232";
	if (chunkId === 6415) return "web.social-sharing-section.min.js?v=1757927405232";
	if (chunkId === 7030) return "component.recipient-form.min.js?v=1757927405232";
	if (chunkId === 1103) return "component.menu-drawer.min.js?v=1757927405232";
	if (chunkId === 9497) return "component.range-slider.min.js?v=1757927405232";
	if (chunkId === 422) return "component.filter-search-filter-drawer.min.js?v=1757927405232";
	if (chunkId === 9442) return "component.product-gallery-modal.min.js?v=1757927405232";
	// return url for filenames based on template
	return "bundle." + chunkId + ".min.js?v=1757927405232";
};